<span nz-icon>
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12.66 11.56-4.19 1.5A1 1 0 0 0 8.8 15c.116 0 .231-.02.34-.06l4.2-1.5a.999.999 0 1 0-.68-1.88Zm-4-3a1 1 0 0 0 0-1.41 3.08 3.08 0 0 0-4.24 0 1 1 0 1 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0Zm7-1.41a3.08 3.08 0 0 0-4.24 0 1 1 0 0 0 1.41 1.41 1 1 0 0 1 1.42 0 1 1 0 0 0 1.41 0 1 1 0 0 0-.04-1.43l.04.02ZM10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z"
      fill="currentColor"
    />
  </svg>
</span>
